/* eslint-disable camelcase */
import { AxiosError, AxiosResponse } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import httpClient from 'utils/httpClient';

export const RETRIEVE_SESSION_EVALUATION = (id: number) => `/v2/sessions/${id}`;

export type RetrieveSessionEvaluationQuery = {
  id: number;
  isCourseUnit: number;
};
export type Evaluation = {
  ratings: {
    strong_points: string;
    suggestion: string;
    weak_points: string;
    listen: any;
    read: any;
    speak: any;
    write: any;
  };
};
export type SessionEvaluationResponse = {
  evaluation: Evaluation;
};

export const retrieveEvalutionSession = ({
  id,
  isCourseUnit,
}: RetrieveSessionEvaluationQuery) => {
  return httpClient.get<SessionEvaluationResponse>(
    RETRIEVE_SESSION_EVALUATION(id),
    {
      params: {
        _evaluation: 1,
        'is-unit': isCourseUnit,
      },
    },
  );
};

export const useRetrieveSessionEvaluation = (
  { id, isCourseUnit }: RetrieveSessionEvaluationQuery,
  opts?: UseQueryOptions<
    AxiosResponse<SessionEvaluationResponse>,
    AxiosError<any>
  >,
) =>
  useQuery<AxiosResponse<SessionEvaluationResponse>, AxiosError<any>>(
    [RETRIEVE_SESSION_EVALUATION(id)],
    () => retrieveEvalutionSession({ id, isCourseUnit }),
    { ...opts, cacheTime: 0 },
  );
